import dayjs from "dayjs";
import {
  Text,
  View,
  StyleSheet,
  Pressable,
  FlatList,
  Image,
  TouchableOpacity,
  ScrollView,
  Dimensions,
} from "react-native";
import LeftIcon from "../../../../assets/images/discounts/left";
import { isic_get_card_microservice } from "../../../store/api";
const SpecificContent = ({ route, navigation }) => {
  const content = route.params.info;
  let pathUrl = `${isic_get_card_microservice}/users/announcements/documents/images/`;
  const win = Dimensions.get("window");
  const ratio = win.width / 412;
  return (
    <View style={styles.root}>
      <TouchableOpacity
        style={styles.closeBtn}
        onPress={() => {
          navigation.navigate("ContentHub");
        }}
      >
        <LeftIcon />
      </TouchableOpacity>
      <ScrollView style={styles.scroll}>
        <View>
          {content.header.image_id ? (
            <Image
              source={{ uri: pathUrl + content.header.image_id }}
              style={{ width: win.width, height: 360 * ratio }}
            />
          ) : null}
          {content.header.info ? (
            <Text style={styles.infoImg}>{content.header.info}</Text>
          ) : null}
        </View>

        <View style={styles.holdText}>
          {/* <Text style={styles.infoImg}>{content.header.info}</Text> */}
          <Text style={styles.title}>{content.title}</Text>
          {content.author != "" ? (
            <Text style={styles.author}>
              {content.author.toLocaleUpperCase()}
            </Text>
          ) : null}

          <Text style={styles.created}>
            {dayjs(content.created_at)
              .format("DD MMM YYYY")
              .toLocaleUpperCase()}
          </Text>
          {content.sections.map((section) => {
            return (
              <>
                {section.type === "text" ? (
                  <>
                    {section.title ? (
                      <Text style={styles.subtitle}>{section.title}</Text>
                    ) : null}
                    <Text style={styles.infos}>{section.content}</Text>
                  </>
                ) : (
                  <View>
                    <Image
                      source={{ uri: pathUrl + section.image_id }}
                      style={{
                        width: win.width * 0.92,
                        height: (214 * win.width) / 380,
                        marginTop: 30,
                      }}
                      resizeMode="contain"
                    />
                    {section.caption ? (
                      <Text style={styles.description}>{section.caption}</Text>
                    ) : null}
                  </View>
                )}
              </>
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
};

export default SpecificContent;

const styles = StyleSheet.create({
  root: {
    width: "100%",
    backgroundColor: "#fff",
    height: "105%",
  },
  banner: {
    flex: 1,
    width: "100%",
  },
  closeBtn: {
    width: 38,
    height: 38,
    backgroundColor: "#0843F5",
    padding: 5,
    borderRadius: 38 / 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    zIndex: 3,
    elevation: 3,
    left: 6,
    top: 60,
  },
  holdText: {
    marginHorizontal: "4%",
    marginBottom: 150,
  },
  infoImg: {
    fontSize: 12,
    color: "#ABABAB",
    fontFamily: "DmSans",
    marginHorizontal: "4%",
    marginTop: 11,
  },

  title: {
    fontSize: 32,
    color: "#3C351F",
    fontFamily: "DmSans-bold",
    marginBottom: 14,
    marginTop: 20,
  },
  author: {
    fontSize: 12,
    color: "#5C553B",
    fontFamily: "DmSans-bold",
  },
  created: {
    fontSize: 12,
    color: "#5C553B",
    fontFamily: "DmSans-bold",
    marginBottom: 20,
    letterSpacing: 1,
  },
  subtitle: {
    fontSize: 18,
    color: "#5C553B",
    fontFamily: "DmSans-bold",
    marginBottom: 8,
  },
  scroll: {},
  infos: {
    fontSize: 18,
    color: "#5C553B",
    fontFamily: "DmSans",
    letterSpacing: -0.2,
    lineHeight: 26,
  },
  description: {
    fontSize: 12,
    color: "#ABABAB",
    fontFamily: "DmSans",
    marginBottom: 24,
  },
  scrollView: { marginBottom: 60 },
});
